// /src/lib/firebase.ts
import { initializeApp, getApps, getApp } from 'firebase/app'
import { getFirestore } from 'firebase/firestore'
import { getDatabase } from 'firebase/database'

const firebaseConfig = {
  apiKey: "AIzaSyABbevRFlkdcJbw_TEU77JCEcCbGWqVlSU",
  authDomain: "coaching-r.firebaseapp.com",
  projectId: "coaching-r",
  storageBucket: "coaching-r.firebasestorage.app",
  messagingSenderId: "399278286505",
  appId: "1:399278286505:web:26be268cbd9dbc1ac8abb8"
};

const app = getApps().length ? getApp() : initializeApp(firebaseConfig)

export const db = getFirestore(app)
export const rtdb = getDatabase(app) // nur wenn du Realtime DB nutzt
